import React from 'react';
import hero from '../../../assets/Hero.svg';
import heroSubmitted from '../../../assets/HeroSubmitted.svg';

export const Hero = () => (
  <img src={hero} alt="" />
);

export const HeroSubmitted = () => (
  <img src={heroSubmitted} alt="" />
);
